(ns hypnos.sleeplab.tile.field.consult-ahi
  "Field for AHI."
  (:require [hypnos.i18n :refer [tr]]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; field

(defn field
  ([state]
   (field state {:disabled false}))
  ([state {:keys [disabled] :or {disabled false}}]
   [:div.field.is-horizontal
    [:div.field-label.is-normal
     [:label.label (tr :ui.label/ahi)]]
    [:div.field-body
     [:div.field.is-narrow
      [:div.control
       [:div.select.is-fullwidth
        [:select
         {:disabled  disabled
          :value     (if-let [val (get-in @state [:patient :patient/last-consult :consult/ahi :value])]
                       val
                       "unknown")
          :on-change (fn [e]
                       (let [val       (-> e .-target .-value)
                             old-value (get-in @state [:patient :patient/last-consult :consult/ahi :value])
                             new-value (when-not (= "unknown" val) (int val))
                             changed?  (or (get-in @state [:patient :patient/last-consult :consult/ahi :dirty?])
                                           (not= new-value old-value))]
                         (swap! state assoc-in
                                [:patient :patient/last-consult :consult/ahi :value]
                                new-value)
                         (swap! state assoc-in
                                [:patient :patient/last-consult :consult/ahi :dirty?]
                                changed?)))
          :on-focus  (fn [_]
                       (swap! state assoc-in
                              [:patient :patient/last-consult :consult/ahi :touched?]
                              true))}
         [:option {:key 0 :value "unknown"} (tr :ui.label/unsure)]
         (doall
          (for [n (range 1 151)]
            [:option {:key (str n) :value n} (str n)]))]]]]]]))
